import React, { useState, useEffect } from 'react';
import { ErrorPage } from './pages/ErrorPage';
import campaignService from '../services/CampaignService';

export function RouteValidator({ children, pathname, hostname }) {
  const [isValidating, setIsValidating] = useState(true);
  const [isValidRoute, setIsValidRoute] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const validateRoute = async () => {
      try {
        setIsValidating(true);
        setError(null);

        // If it's the root path on karrieresichern.de, it's invalid
        if (hostname === 'karrieresichern.de' && pathname === '/') {
          setIsValidRoute(false);
          setIsValidating(false);
          return;
        }

        // Check if it's an apply route pattern - always allow these
        const applyRoutePattern = /^\/apply\/([^/]+)\/?$/;
        if (applyRoutePattern.test(pathname)) {
          setIsValidRoute(true);
          setIsValidating(false);
          return;
        }

        // Check if it's a landing page route pattern
        const landingPagePattern = /^\/([^/]+)\/([^/]+)(?:\/([^/]+))?\/?$/;
        const match = pathname.match(landingPagePattern);
        
        if (match) {
          const [, companyName, campaignName, landingPageName = 'landing'] = match;
          
          // Check if this route exists in the database
          const routeResult = await campaignService.getCampaignByRoute(companyName, campaignName, landingPageName);
          
          if (routeResult.success) {
            setIsValidRoute(true);
          } else {
            // Fallback: check all campaigns
            const allCampaignsResult = await campaignService.getCampaigns();
            if (allCampaignsResult.success) {
              const campaign = allCampaignsResult.data.find(c => 
                c.company_name === companyName && 
                c.campaign_name === campaignName && 
                c.landing_page_name === landingPageName
              );
              setIsValidRoute(!!campaign);
            } else {
              setIsValidRoute(false);
            }
          }
        } else {
          // Not a recognized route pattern, show error
          setIsValidRoute(false);
        }
      } catch (err) {
        console.error('Error validating route:', err);
        setError('Fehler bei der Routenvalidierung');
        setIsValidRoute(false);
      } finally {
        setIsValidating(false);
      }
    };

    validateRoute();
  }, [pathname, hostname]);

  if (isValidating) {
    return (
      <div className="bg-white dark:bg-slate-900 min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
          <p className="text-slate-600 dark:text-slate-400">Überprüfe Route...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return <ErrorPage />;
  }

  if (!isValidRoute) {
    return <ErrorPage />;
  }

  return children;
}
